import React from "react";
import { Link } from "react-router-dom";

const AffiliateLandingPage = () => {
  return (
    <div className="min-h-screen bg-white px-6 py-12 flex flex-col items-center justify-start">
      {/* Hero Section */}
      <div className="max-w-5xl w-full text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Partner with Bellhopt & Earn on Every Order
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Bellhopt is a premium grocery delivery & concierge service for short-term rentals — and it’s completely free to promote.
        </p>
        <Link to="/signup/affiliate" className="bg-black text-white px-6 py-3 rounded-full font-semibold text-base hover:bg-gray-800 transition-all">
          Join as an Affiliate
        </Link>
      </div>

      {/* Feature Highlights */}
      <div className="mt-16 max-w-4xl grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
        <div className="bg-gray-50 p-6 rounded-2xl shadow-sm border">
          <h2 className="text-xl font-semibold mb-2">💸 Free to Join</h2>
          <p className="text-gray-600">
            No contracts. No fees. Bellhopt is free to promote and built to help you grow your own brand too.
          </p>
        </div>

        <div className="bg-gray-50 p-6 rounded-2xl shadow-sm border">
          <h2 className="text-xl font-semibold mb-2">💼 Earn 5% Per Order</h2>
          <p className="text-gray-600">
            For every guest order placed through your referral, you earn a 5% commission. It's passive income with premium upside.
          </p>
        </div>

        <div className="bg-gray-50 p-6 rounded-2xl shadow-sm border">
          <h2 className="text-xl font-semibold mb-2">⭐ 5-Star Guest Experience</h2>
          <p className="text-gray-600">
            Guests get top-tier service: fridge-stocking, pantry organization, and seamless concierge-level care.
          </p>
        </div>

        <div className="bg-gray-50 p-6 rounded-2xl shadow-sm border">
          <h2 className="text-xl font-semibold mb-2">🧤 White-Glove Concierge Team</h2>
          <p className="text-gray-600">
            Our staff are trained in hospitality and guest satisfaction — no delivery drivers here, just pros.
          </p>
        </div>
      </div>

      {/* Guest Preview Iframe */}
      <div className="w-full max-w-6xl mx-auto mt-20 relative shadow-xl border rounded-2xl overflow-hidden">
        <div className="text-center text-lg font-semibold py-4 bg-gray-100 border-b">
          See What Guests Experience
        </div>
        <iframe
          src="https://bellhopt.com/guest/NWAEYL"
          title="Bellhopt Guest Preview"
          className="w-full h-[700px] pointer-events-none"
          style={{ filter: "grayscale(0.05)" }}
        ></iframe>
        <div className="absolute top-[52px] left-0 w-full h-[700px] z-10 pointer-events-auto cursor-not-allowed"></div>
      </div>

      {/* Final CTA */}
      <div className="mt-20 text-center">
        <h3 className="text-2xl font-bold text-gray-800 mb-4">Let Bellhopt Work For You</h3>
        <p className="text-gray-600 mb-6">
          Affiliates earn with every referral and help bring unforgettable experiences to short-term rental guests.
        </p>
        <Link to="/signup/affiliate" className="bg-black text-white px-8 py-3 rounded-full font-semibold hover:bg-gray-800 transition-all">
          Become a Bellhopt Affiliate
        </Link>
      </div>
    </div>
  );
};

export default AffiliateLandingPage;
